// frontend/src/components/layout/Header.js (نسخه هوشمند شده)

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle, FaBell, FaSignOutAlt } from 'react-icons/fa';
import '../../assets/styles/global.css';

const Header = () => {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    // --- خواندن اطلاعات کاربر از حافظه ---
    const userRole = localStorage.getItem('userRole');
    const userFullName = localStorage.getItem('userFullName');
    const userName = localStorage.getItem('userName');
    
    // --- تعیین نام نمایشی و عنوان پنل بر اساس نقش ---
    const displayName = userFullName || userName || 'کاربر';
    const panelTitle = userRole === 'Teacher' ? 'پنل مدیریت معلم' : 'پنل مدیریت سامانه';

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    return (
        <header className="header">
            <div className="header-title"><h2>{panelTitle}</h2></div>
            <div className="header-profile">
                <div className="notification-icon">
                    <FaBell />
                    <span className="notification-badge">3</span>
                </div>
                <div className="user-menu" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    <span>{displayName} خوش آمدید</span>
                    <FaUserCircle className="user-avatar" />
                    {dropdownOpen && (
                        <div className="dropdown-menu">
                            <button onClick={handleLogout}><FaSignOutAlt /><span>خروج از حساب</span></button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;